import { forwardRef } from 'react';

import { inputStyle } from '@components/Input/Input';
import Skeleton from '@components/Skeleton';
import clsx from 'clsx';
import Input, { InputSize, type InputProps } from '../Input';

type InputGroupProps = {
  id: string;
  label?: string;
  required?: boolean;
  leftRequired?: boolean;
  className?: string; // input groups className
  inputClassName?: string; // input className
  labelClassName?: string; // label className
} & InputProps;

const InputGroup = forwardRef<HTMLInputElement, InputGroupProps>(
  (
    {
      id,
      className,
      label,
      labelClassName,
      inputClassName,
      required,
      leftRequired = false,
      error,
      ...props
    },
    ref
  ) => {
    const propsToSend = { ...props, className: inputClassName };
    return (
      <div className={clsx('flex flex-col', className)}>
        <label htmlFor={id} className={labelClassName}>
          {required && leftRequired && <span className="mr-3px text-h4 text-ivas-blue">*</span>}
          {label}
          {required && !leftRequired && <span className="ml-3px text-h4 text-ivas-blue">*</span>}
        </label>
        {props.isLoading ? (
          <Skeleton
            containerClassName="border-1px border-transparent"
            className={inputStyle.sizes[props?.size as InputSize]}
          />
        ) : (
          <Input id={id} ref={ref} error={error} {...propsToSend} />
        )}
        {error && (
          <p className="mt-1 font-medium text-ivas-invalid text-caption1"> {error?.message}</p>
        )}
      </div>
    );
  }
);

export default InputGroup;
